"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebsiteFastTagRefreshClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
const WebsiteFastTagError_1 = require("./WebsiteFastTagError");
const WEBSITE_FAST_TAG_REFRESH_URL = process.env.WEBSITE_FAST_TAG_REFRESH_URL;
const WEBSITE_FAST_TAG_REFRESH_BASIC_AUTH_USER = process.env.WEBSITE_FAST_TAG_REFRESH_BASIC_AUTH_USER;
const WEBSITE_FAST_TAG_REFRESH_BASIC_AUTH_PASSWORD = process.env.WEBSITE_FAST_TAG_REFRESH_BASIC_AUTH_PASSWORD;
class WebsiteFastTagRefreshClient extends base_client_1.ApiBasicAuthClient {
    constructor(url = WEBSITE_FAST_TAG_REFRESH_URL, user = WEBSITE_FAST_TAG_REFRESH_BASIC_AUTH_USER, password = WEBSITE_FAST_TAG_REFRESH_BASIC_AUTH_PASSWORD) {
        super({
            baseURL: `${url}/v1/`,
            basicAuthPassword: password,
            basicAuthUser: user,
        });
        if (!user || !password) {
            commons_logs_1.log.warn("Missing WEBSITE_FAST_TAG_REFRESH_BASIC_AUTH_USER and WEBSITE_FAST_TAG_REFRESH_BASIC_AUTH_PASSWORD environment variables");
        }
    }
    async refreshSeller(sellerId) {
        try {
            return await this.post(`/refresh/seller/${sellerId}`, undefined);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [WebsiteFastTagError_1.WebsiteFastTagError.NOT_FOUND, WebsiteFastTagError_1.WebsiteFastTagError.REFRESH_ALREADY_IN_PROGRESS]);
        }
    }
    async refreshStateCoverage() {
        try {
            return await this.post(`/coverage/servicelevel/refresh`, undefined);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err);
        }
    }
    async refreshWebsiteSeller(sellerId) {
        try {
            return await this.post(`/website/refresh/seller/${sellerId}`, undefined);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [WebsiteFastTagError_1.WebsiteFastTagError.NOT_FOUND, WebsiteFastTagError_1.WebsiteFastTagError.REFRESH_ALREADY_IN_PROGRESS]);
        }
    }
    async refreshWarehouseData(packageWindowStartTime, packageWindowEndTime) {
        try {
            return await this.post("/warehouse/refresh", undefined, {
                packageWindowStartTime,
                packageWindowEndTime,
            });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err);
        }
    }
}
exports.WebsiteFastTagRefreshClient = WebsiteFastTagRefreshClient;
//# sourceMappingURL=WebsiteFastTagRefreshClient.js.map